import {
  createTableTabNavigationInput,
  type SelectionUiInteraction,
  type SharedEventLoop,
  type TableNavigationAdapter,
} from '@databases/selections';
import { DatabaseLayoutType } from '@databases/types/database/view';
import { TABLE_V2_LAYOUT_ID } from '@databases/view-layout-table-v2/id';

import {
  type SelectionInputFeature,
  SelectionFeatureKeys,
} from '../../features/types.ts';

export interface TableTabNavigationKeyboardInputFeatureDeps {
  sharedLoop: SharedEventLoop;
  adapter: TableNavigationAdapter;
  onSelectionUiInteraction?: (event: SelectionUiInteraction) => void;
}

/**
 * Registers table Tab navigation.
 *
 * The feature remains table-layout scoped because it depends on visible row and
 * field ordering supplied by the Databases app adapter.
 */
export function createTableTabNavigationKeyboardInputFeature(
  deps: TableTabNavigationKeyboardInputFeatureDeps,
): SelectionInputFeature {
  return {
    key: SelectionFeatureKeys.TABLE_TAB_NAVIGATION_KEYBOARD_INPUT,
    type: 'input',
    isEnabled: (ctx) =>
      ctx.layoutType === DatabaseLayoutType.TABLE ||
      ctx.layoutType === TABLE_V2_LAYOUT_ID,
    factory: (machine) =>
      createTableTabNavigationInput(machine, deps.sharedLoop, {
        adapter: deps.adapter,
        onSelectionUiInteraction: deps.onSelectionUiInteraction,
      }),
  };
}
